
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import shared$1 from './shared.js';
import uid$1 from './uid.js';

var shared = shared$1;
var uid = uid$1;

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

export { sharedKey as default };
//# sourceMappingURL=shared-key.js.map
